import { z } from 'zod';

export const booleanTypeLiteralSchema = z.literal('boolean');
export const dateTypeLiteralSchema = z.literal('date');
export const integerTypeLiteralSchema = z.literal('integer');
export const jobTypeLiteralSchema = z.literal('job');
export const percentTypeLiteralSchema = z.literal('percent');
export const searchTypeLiteralSchema = z.literal('search');
export const skillTypeLiteralSchema = z.literal('skill');
export const skilltypeTypeLiteralSchema = z.literal('skilltype');
export const stateTypeLiteralSchema = z.literal('state');
export const stringTypeLiteralSchema = z.literal('string');
export const userTypeLiteralSchema = z.literal('user');
export const uuidTypeLiteralSchema = z.literal('uuid');

const filterBaseResponseSchema = z.object({
    field: z.string(),
});

export const filterBooleanResponseSchema = filterBaseResponseSchema.extend({
    type: booleanTypeLiteralSchema,
});

export type FilterBooleanResponse = z.infer<typeof filterBooleanResponseSchema>;

export const filterStringResponseSchema = filterBaseResponseSchema.extend({
    type: stringTypeLiteralSchema,
    values: z.string().nullable().array().optional(),
});

export type FilterStringResponse = z.infer<typeof filterStringResponseSchema>;

export const filterIntegerResponseSchema = filterBaseResponseSchema.extend({
    type: integerTypeLiteralSchema,
    values: z.number().nullable().array().optional(),
});

export type FilterIntegerResponse = z.infer<typeof filterIntegerResponseSchema>;

export const filterDateResponseSchema = filterBaseResponseSchema.extend({
    type: dateTypeLiteralSchema,
});

export type FilterDateResponse = z.infer<typeof filterDateResponseSchema>;

export const filterSkillResponseSchema = filterBaseResponseSchema.extend({
    type: skillTypeLiteralSchema,
});

export type FilterSkillResponse = z.infer<typeof filterSkillResponseSchema>;

export const filterUuidResponseSchema = filterBaseResponseSchema.extend({
    type: uuidTypeLiteralSchema,
});

export type FilterUuidResponse = z.infer<typeof filterUuidResponseSchema>;

export const filterSearchResponseSchema = filterBaseResponseSchema.extend({
    type: searchTypeLiteralSchema,
});

export const filterStateResponseSchema = filterBaseResponseSchema.extend({
    type: stateTypeLiteralSchema,
});

export const filterUserResponseSchema = filterBaseResponseSchema.extend({
    type: userTypeLiteralSchema,
    values: z
        .object({
            id: z.uuid(),
            firstName: z.string(),
            lastName: z.string(),
        })
        .nullable()
        .array()
        .optional(),
});

export type FilterUserResponse = z.infer<typeof filterUserResponseSchema>;

export const filterJobResponseSchema = filterBaseResponseSchema.extend({
    type: jobTypeLiteralSchema,
});

export const filterPercentResponseSchema = filterBaseResponseSchema.extend({
    type: percentTypeLiteralSchema,
});

export const filterSkillTypeResponseSchema = filterBaseResponseSchema.extend({
    type: skilltypeTypeLiteralSchema,
    values: z.union([z.literal('hard'), z.literal('soft'), z.literal('language')]).array(),
});

const filterInFilterResponseSchema = z.union([
    filterBooleanResponseSchema,
    filterDateResponseSchema,
    filterIntegerResponseSchema,
    filterJobResponseSchema,
    filterPercentResponseSchema,
    filterSearchResponseSchema,
    filterSkillResponseSchema,
    filterSkillTypeResponseSchema,
    filterStringResponseSchema,
    filterUserResponseSchema,
    filterUuidResponseSchema,
]);

export type FilterInFilterResponse = z.infer<typeof filterInFilterResponseSchema>;

export const filterResponseSchema = z.object({
    filters: filterInFilterResponseSchema.array(),
});

export type FilterResponse = z.infer<typeof filterResponseSchema>;
